__turbopack_context__.v({
  "applied": "promo-code-module-scss-module__ppVeFq__applied",
  "check": "promo-code-module-scss-module__ppVeFq__check",
  "code": "promo-code-module-scss-module__ppVeFq__code",
  "form": "promo-code-module-scss-module__ppVeFq__form",
  "input": "promo-code-module-scss-module__ppVeFq__input",
  "label": "promo-code-module-scss-module__ppVeFq__label",
  "message": "promo-code-module-scss-module__ppVeFq__message",
  "root": "promo-code-module-scss-module__ppVeFq__root",
  "submit": "promo-code-module-scss-module__ppVeFq__submit",
});
